// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3SpC4","bigColWidth":"Table_bigColWidth__2TgCZ","biggerColWidth":"Table_biggerColWidth__1DNYk","row":"Table_row__OXFFU","col":"Table_col__3xMc8"};